/* Edit CO to make the site yours. The rest is placeholder content. */
export const CO = {
  name: "True Skill Remodels",
  tagline: "",
  phone: "(727) 999-9999",
  email: "info@trueskillremodels.com",
  hours: "Monday to Friday, 7:30 am to 5:00 pm",
  area: "Homes within 100 miles of our shop",
};

export const FACTS = [
  ["Licensed and insured", "General contractor license and liability coverage on every job."],
  ["One fixed price", "The contract has one number in it. Changes are written up before work starts."],
  ["One crew", "The people who demo your kitchen are the people who finish it."],
  ["Two-year warranty", "Workmanship is covered in writing for two years after the walkthrough."],
];

export const SERVICES = [
  ["Kitchens", "Layout changes, cabinetry, counters, lighting, and plumbing moves.", "10 to 14 weeks"],
  ["Bathrooms", "Full gut renovations, tile work, curbless showers, and accessible layouts.", "5 to 8 weeks"],
  ["Whole-home renovations", "Every room on one schedule, built from one set of drawings.", "5 to 9 months"],
  ["Additions and layout changes", "Opening walls, adding square footage, and setting new structural beams.", "4 to 7 months"],
  ["Basements and attics", "Finished living space with proper egress, insulation, and moisture control.", "8 to 12 weeks"],
];

export const STEPS = [
  ["Week 0", "Site visit", "We measure, listen, and look at what is behind the walls. You get a written scope within five days."],
  ["Weeks 1 to 3", "Drawings and one price", "Elevations, a materials list, and a fixed price. We revise until it is right."],
  ["Weeks 3 to 6", "Permits and ordering", "We file the permits and order cabinets, tile, and fixtures so nothing waits on a truck."],
  ["Weeks 6 to 18", "Build", "Demolition to final paint, with a weekly site meeting and a photo update every Friday."],
  ["Final week", "Walkthrough", "We go through the punch list with you on site and leave when you sign off."],
];

export const PROJECTS = [
  {
    name: "Alder Street kitchen", kind: "Kitchen in a 1962 ranch", size: "212 sq ft", time: "13 weeks", year: "2025",
    note: "We took out the wall between the kitchen and dining room, set a 14 foot beam, and ran one continuous counter along the north wall under a new window.",
    mats: [["Green shaker cabinets", "#2E4A43"], ["Honed quartz counters", "#E9E8E2"], ["3 by 6 ceramic tile", "#E4EAE8"], ["Aged brass pulls", "#B9924A"], ["White oak floor", "#C9A074"], ["Brushed steel hood", "#B9C0C5"]],
  },
  {
    name: "Pennant Court primary bath", kind: "Bathroom in a 1994 colonial", size: "96 sq ft", time: "7 weeks", year: "2025",
    note: "A closet gave up four feet so the room could hold a double vanity and a curbless shower with a linear drain.",
    mats: [["Walnut vanity", "#6B4A33"], ["Large format porcelain", "#CFCBC3"], ["Plaster finish walls", "#E6E1D8"], ["Matte black fixtures", "#2B2E31"], ["Clear shower glass", "#CFE2EA"], ["Heated tile floor", "#BDB8AE"]],
  },
  {
    name: "Harbor Row cape", kind: "Whole home, 1948 cape", size: "1,840 sq ft", time: "7 months", year: "2024",
    note: "New wiring, plumbing, and heating throughout, a rebuilt staircase, and a rear dormer that added a fourth bedroom.",
    mats: [["Oak stair treads", "#B58B5E"], ["Painted trim", "#F1F2EE"], ["Black window frames", "#23272B"], ["Soft sage walls", "#D5DCD5"], ["Cedar shingles", "#A98A6A"], ["Slate hearth", "#4A5258"]],
  },
  {
    name: "Linden Lane basement", kind: "Basement in a 1978 split-level", size: "740 sq ft", time: "10 weeks", year: "2024",
    note: "Interior drainage and a sump pump, an egress window, and a finished room with a wet bar plumbed from scratch.",
    mats: [["Vinyl plank floor", "#B9A58C"], ["Painted drywall", "#E4E7E3"], ["Walnut wet bar", "#6B4A33"], ["Quartz bar top", "#ECECE6"], ["Recessed lighting", "#F2E6C8"], ["Rigid foam insulation", "#9FB6C9"]],
  },
];
